import React, { useMemo } from 'react'
import SevenStar from './7star'
import SevenStarJasem from './7starjasem'
import Syzygy from './syzygy'
import convertLatesFromMinutesToHours from 'utils/convertLatesFromMinutesToHours'

const HoursTable = ({ company = '', data = [], store = '' }) => {

    let transformedRows = useMemo(() => {
        return data.map(row => convertLatesFromMinutesToHours(row));
    }, [data]);


    /*

    switch (company) {
        case '7star':
            return <SevenStar data={transformedRows} store={store} />
        case '7starjasem':
            return <SevenStarJasem data={transformedRows} store={store} />
        case 'syzygy':
            return <Syzygy data={transformedRows} store={store} />

        default:
            return null
    }
            */

    return <SevenStar data={transformedRows} store={store} />
}

export default HoursTable